import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice, DatabaseRelation } from '../alcance/interfaces/database';

@Injectable({providedIn: 'root'})
export class BlocoNotaDBService extends DatabaseService {
    override classname = 'BlocoNotaDBService';
    override table = 'bloco_nota';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    override indices: DatabaseIndice[] = [
        {name: 'by_id', field: 'id', unique: false, multiEntry: false},
        {name: 'by_edificacao', field: 'edificacao_id', unique: false, multiEntry: false},
        {name: 'by_equipamento', field: 'equipamento_id', unique: false, multiEntry: false},
        {name: 'by_tipo', field: 'tipo', unique: false, multiEntry: false},
        {name: 'by_solicitacao_tipo', field: 'solicitacao_tipo', unique: false, multiEntry: false},
        {name: 'by_status', field: 'status', unique: false, multiEntry: false},
        {name: 'by_titulo', field: 'titulo', unique: false, multiEntry: false},
        {name: 'by_descricao', field: 'descricao', unique: false, multiEntry: false},
        {name: 'by_updated_at', field: 'updated_at', unique: false, multiEntry: false},
        {name: 'by_sinc', field: 'sinc', unique: false, multiEntry: false},
    ];
    protected override relations: DatabaseRelation[] = [
        {name: 'equipamento', table: 'equipamento', field: 'equipamento_id', type: 'foreign'},
        {name: 'usuario', table: 'usuario', field: 'usuario_id', type: 'foreign'},
    ];

    protected override filterSql(sql: string, params: any): string {
        const add = (clause: string) => sql += (sql.includes('WHERE') ? ' AND ' : ' WHERE ') + clause;
        if(params?.edificacao_id) add(`by_edificacao = '${params.edificacao_id}'`);
        if(params?.equipamento_id) add(`by_equipamento = '${params.equipamento_id}'`);
        if(params?.tipo) add(`by_tipo = '${params.tipo}'`);
        if(params?.solicitacao_tipo) add(`by_solicitacao_tipo = '${params.solicitacao_tipo}'`);
        if(params?.status) add(`by_status = '${params.status}'`);
        if(params?.descricao){
            const termo = String(params.descricao).replace(/'/g, "''");
            add(`(by_titulo LIKE '%${termo}%' OR by_descricao LIKE '%${termo}%')`);
        }
        return sql;
    }
}
